<template>
  <NuxtLayout name="default">
    <template #header>
      <RevBanner
        v-if="lrrBannerIsDisplayed"
        data-test="lrr-banner"
        :label="i18n(translations.helpCenterLateResponseRateBanner)"
        @close="hideLrrBanner"
      />
      <div class="bg-surface-brand-hi pb-8 md:pb-24">
        <Breadcrumb />
        <div
          class="mx-auto max-w-full px-24 max-md:mt-24 md:max-w-[1184px] md:px-32"
        >
          <div class="h-12 md:h-16 lg:h-20">
            <TheLogo decoding="sync" loading="eager" />
          </div>
          <div class="text-static-default-hi heading-2 mt-8 max-md:hidden">
            {{ i18n(translations.helpCenterLayoutTitle) }}
          </div>
        </div>
      </div>
    </template>
    <TheMainContent>
      <slot />
    </TheMainContent>
  </NuxtLayout>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevBanner } from '@ds/components/Banner'

import TheMainContent from '~/components/TheMainContent/TheMainContent.vue'
import { useCheckForLrr } from '~/scopes/care-commons/composables/useCheckForLrr'
import Breadcrumb from '~/scopes/help-center/components/Breadcrumb/Breadcrumb.vue'
import TheLogo from '~/scopes/navigation/components/TheLogo.vue'

import translations from './HelpCenterLayout.translations'

const i18n = useI18n()
const { lrrIsOngoing } = useCheckForLrr()
const bannerIsClosed = ref(false)
const hideLrrBanner = () => {
  bannerIsClosed.value = true
}

const lrrBannerIsDisplayed = computed(
  () => lrrIsOngoing.value && !bannerIsClosed.value,
)
</script>
